{
  "en": {
    "form": {
      "actions": {
        "cancel": "Cancel",
        "clear": "Clear",
        "closeFullPage": "Close full page",
        "copyText": "Click to copy text",
        "next": "Next",
        "openFullPage": "Open in full page",
        "save": "Save",
        "saveChanges": "Save changes",
        "search": "Search...",
        "send": "Send",
        "send_and_create_another": "Send and create another",
        "submit": "Submit",
        "submit_and_create_another": "Submit and create another"
      },
      "back": "Previous step",
      "labels": {
        "columns": "Columns",
        "no_results": "No results"
      },
      "notifications": {
        "textHasBeenCopied": "Text has been copied"
      },
      "password": "Password",
      "shortcuts": {
        "save_mac": "⌘ + Enter to save",
        "save_windows": "Ctrl + Enter to save",
        "send_mac": "⌘ + Enter to send",
        "send_windows": "Ctrl + Enter to send"
      },
      "steps": "Step {count} of {total}",
      "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> to continue."
    }
  }
}